const mergeUrl = (baseUrl, ...slugs) => {
    // Ensure the protocol is correctly formatted
    const [protocol, rest] = baseUrl.split('://');
    if (!rest) throw new Error('Invalid base URL');

    // Normalize and clean up slashes
    const cleanedSlugs = [rest, ...slugs]
        .map(slug => slug?.replace(/^\/|\/$/g, '')) // Remove leading & trailing slashes
        .filter(Boolean); // Remove empty segments

    // Join all parts with a single slash
    return `${protocol}://${cleanedSlugs.join('/')}/`;
}

const ensureTrailingSlash = (url) => {
    if (url) return url?.toString()?.endsWith('/') ? url : `${url}/`;
    return url
}

export {ensureTrailingSlash, mergeUrl}